
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/debug.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-debug-demo-debug"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/debug.zh-CN.md?type=demo')
};